function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import * as r from "react";
import { screenReaderOnly as a } from "./screen-reader-only.css-mistica.js";
import { getPrefixedDataAttributes as l } from "./utils/dom.js";
const m = (param)=>{
    let { children: t, dataAttributes: n } = param;
    const s = l(n, "ScreenReaderOnly");
    if (r.Children.count(t) === 1) {
        const e = r.Children.only(t);
        if (/*#__PURE__*/ r.isValidElement(e)) return /*#__PURE__*/ r.cloneElement(e, _object_spread({
            className: e.props.className ? e.props.className + " " + a : a
        }, s));
    }
    return /* @__PURE__ */ o("div", _object_spread_props(_object_spread({
        className: a
    }, s), {
        children: t
    }));
}, d = m;
export { d as default };
